import { createSelector } from '@reduxjs/toolkit';

import { useReduxSelector } from '../../../hooks';

import { browserPageSelector } from './root';

export const browserPageIsPageReloadingSelector = createSelector(browserPageSelector, state => state.isPageReloading);

export function useBrowserPageIsPageReloadingSelector(): boolean {
  return useReduxSelector(browserPageIsPageReloadingSelector);
}
